export const translateMask = (mask) => {
  let openTo = 'day'
  const views = []

  if (!mask) {
    views.push('day')
    views.push('month')
    views.push('year')
  } else {
    if (mask.toUpperCase().includes('DD')) views.push('day')
    if (mask.toUpperCase().includes('MM')) views.push('month')
    if (mask.toUpperCase().includes('YYYY')) views.push('year')
    if (mask.toUpperCase().includes('HH24')) views.push('hours')
    if (mask.toUpperCase().includes('MI')) views.push('minutes')
    if (mask.toUpperCase().includes('SS')) views.push('seconds')

    if (views.length === 1 && views[0] === 'year') openTo = 'year'
    if (!views.includes('day') && !views.includes('month') && !views.includes('year'))
      openTo = 'hour'
  }

  return { openTo, views }
}
